module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    ref: "estimate-cost",
    attrs: {
      "name": "estimate-cost",
      "height": "auto",
      "width": _vm.isCompare ? 1160 : 600,
      "pivotY": 0.2,
      "pivotX": 0.5
    },
    on: {
      "before-open": _vm.beforeOpen,
      "opened": _vm.opened
    }
  }, [(_vm.modalLoading) ? [_c('div', {
    staticClass: "preloader"
  }, [_c('div', {
    staticClass: "preloader-wrapper small active"
  }, [_c('div', {
    staticClass: "spinner-layer"
  }, [_c('div', {
    staticClass: "circle-clipper left"
  }, [_c('div', {
    staticClass: "circle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "gap-patch"
  }, [_c('div', {
    staticClass: "circle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "circle-clipper right"
  }, [_c('div', {
    staticClass: "circle"
  })])])])])] : [(_vm.isCompare) ? _c('div', {
    staticClass: "modal-content compare-mode"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._v("Estimate Print Costs Comparison")]), _vm._v(" "), _c('form', {
    staticClass: "modal-form"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "input-field col s6 cost"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.costPerHour),
      expression: "formData.costPerHour"
    }],
    attrs: {
      "type": "number",
      "min": "0",
      "name": "costPerHour",
      "id": "costPerHour"
    },
    domProps: {
      "value": (_vm.formData.costPerHour)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "costPerHour", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "active",
    attrs: {
      "for": "costPerHour"
    }
  }, [_vm._v("Cost per Print Hour")])]), _vm._v(" "), _c('div', {
    staticClass: "input-field col s6 cost"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.costPerKg),
      expression: "formData.costPerKg"
    }],
    attrs: {
      "type": "number",
      "min": "0",
      "name": "costPerKg",
      "id": "costPerKg"
    },
    domProps: {
      "value": (_vm.formData.costPerKg)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "costPerKg", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "active",
    attrs: {
      "for": "costPerKg"
    }
  }, [_vm._v("Cost per kg")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "radio-group col s6"
  }, [_c('div', {
    staticClass: "radio-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.multiplier),
      expression: "formData.multiplier"
    }],
    attrs: {
      "type": "radio",
      "name": "multiplier",
      "id": "multiplier"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.formData.multiplier, true)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.formData, "multiplier", true)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "multiplier"
    }
  }, [_vm._v("\n                                Multiplier\n                            ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.multiplier),
      expression: "formData.multiplier"
    }],
    attrs: {
      "type": "radio",
      "name": "multiplier",
      "id": "flat"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.formData.multiplier, false)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.formData, "multiplier", false)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "flat"
    }
  }, [_vm._v("\n                                Flat Dollar Amount\n                            ")])])]), _vm._v(" "), (_vm.formData.multiplier) ? _c('div', {
    staticClass: "input-field col s6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.overhead),
      expression: "formData.overhead"
    }],
    attrs: {
      "type": "number",
      "name": "overhead",
      "id": "overhead",
      "step": "0.1",
      "min": "0"
    },
    domProps: {
      "value": (_vm.formData.overhead)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "overhead", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "active",
    attrs: {
      "for": "overhead"
    }
  }, [_vm._v("Overhead and Profit")])]) : _vm._e(), _vm._v(" "), (!_vm.formData.multiplier) ? _c('div', {
    staticClass: "input-field col s6 cost"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.overheadFlat),
      expression: "formData.overheadFlat"
    }],
    attrs: {
      "type": "number",
      "name": "overheadFlat",
      "id": "overheadFlat",
      "step": "0.1"
    },
    domProps: {
      "value": (_vm.formData.overheadFlat)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "overheadFlat", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "active",
    attrs: {
      "for": "overhead"
    }
  }, [_vm._v("Overhead and Profit")])]) : _vm._e(), _vm._v(" "), (_vm.validationError) ? _c('div', {
    staticClass: "error"
  }, [_vm._v("\n                        " + _vm._s(_vm.validationError) + "\n                    ")]) : _vm._e()]), _vm._v(" "), (_vm.estimates.length) ? [_c('div', {
    staticClass: "row col"
  }, [_c('table', {
    staticClass: "estimate-table"
  }, [_c('tr', [_c('th', {
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v("Filename")]), _vm._v(" "), _c('th', {
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v("Objective Function")]), _vm._v(" "), _c('th', {
    staticClass: "distortion",
    attrs: {
      "colspan": "12"
    }
  }, [_vm._v("Max Distortion, mm")]), _vm._v(" "), _c('th', {
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v("Material Required, kg")]), _vm._v(" "), _c('th', {
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v("Print Time, h")]), _vm._v(" "), _c('th', {
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v("Material Cost, $")]), _vm._v(" "), _c('th', {
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v("Time Cost, $")]), _vm._v(" "), _c('th', {
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v("Total Cost, $")])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("On-supp")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("Off-supp")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("Stress")])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "distortion"
  }, [_vm._v("X")]), _vm._v(" "), _c('th', {
    staticClass: "distortion"
  }, [_vm._v("Y")]), _vm._v(" "), _c('th', {
    staticClass: "distortion"
  }, [_vm._v("Z")]), _vm._v(" "), _c('th', {
    staticClass: "distortion"
  }, [_vm._v("Normal")]), _vm._v(" "), _c('th', {
    staticClass: "distortion"
  }, [_vm._v("X")]), _vm._v(" "), _c('th', {
    staticClass: "distortion"
  }, [_vm._v("Y")]), _vm._v(" "), _c('th', {
    staticClass: "distortion"
  }, [_vm._v("Z")]), _vm._v(" "), _c('th', {
    staticClass: "distortion"
  }, [_vm._v("Normal")]), _vm._v(" "), _c('th', {
    staticClass: "distortion"
  }, [_vm._v("X")]), _vm._v(" "), _c('th', {
    staticClass: "distortion"
  }, [_vm._v("Y")]), _vm._v(" "), _c('th', {
    staticClass: "distortion"
  }, [_vm._v("Z")]), _vm._v(" "), _c('th', {
    staticClass: "distortion"
  }, [_vm._v("Normal")])]), _vm._v(" "), _vm._l((_vm.estimates), function(estimate) {
    return _c('tr', {
      key: estimate.jobOutputPathKey,
      staticClass: "estimate-row"
    }, [_c('td', [_c('div', {
      staticClass: "file"
    }, [_c('i', {
      staticClass: "material-icons a3d color btn-delete-estimate",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.deleteJobFromEstimate(estimate.jobOutputPathKey)
        }
      }
    }, [_vm._v("\n                                            clear\n                                        ")]), _vm._v(" "), _c('div', {
      staticClass: "filename"
    }, [_vm._v(_vm._s(estimate.filename))])])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(estimate.objectiveFunc))]), _vm._v(" "), _c('td', {
      staticClass: "distortion"
    }, [_vm._v(_vm._s(_vm.formatDistortion(estimate.distortion, 'on_x')))]), _vm._v(" "), _c('td', {
      staticClass: "distortion"
    }, [_vm._v(_vm._s(_vm.formatDistortion(estimate.distortion, 'on_y')))]), _vm._v(" "), _c('td', {
      staticClass: "distortion"
    }, [_vm._v(_vm._s(_vm.formatDistortion(estimate.distortion, 'on_z')))]), _vm._v(" "), _c('td', {
      staticClass: "distortion"
    }, [_vm._v(_vm._s(_vm.formatDistortion(estimate.distortion, 'on_normal')))]), _vm._v(" "), _c('td', {
      staticClass: "distortion"
    }, [_vm._v(_vm._s(_vm.formatDistortion(estimate.distortion, 'off_x')))]), _vm._v(" "), _c('td', {
      staticClass: "distortion"
    }, [_vm._v(_vm._s(_vm.formatDistortion(estimate.distortion, 'off_y')))]), _vm._v(" "), _c('td', {
      staticClass: "distortion"
    }, [_vm._v(_vm._s(_vm.formatDistortion(estimate.distortion, 'off_z')))]), _vm._v(" "), _c('td', {
      staticClass: "distortion"
    }, [_vm._v(_vm._s(_vm.formatDistortion(estimate.distortion, 'off_normal')))]), _vm._v(" "), _c('td', {
      staticClass: "distortion"
    }, [_vm._v(_vm._s(_vm.formatDistortion(estimate.distortion, 'stress_x')))]), _vm._v(" "), _c('td', {
      staticClass: "distortion"
    }, [_vm._v(_vm._s(_vm.formatDistortion(estimate.distortion, 'stress_y')))]), _vm._v(" "), _c('td', {
      staticClass: "distortion"
    }, [_vm._v(_vm._s(_vm.formatDistortion(estimate.distortion, 'stress_z')))]), _vm._v(" "), _c('td', {
      staticClass: "distortion"
    }, [_vm._v(_vm._s(_vm.formatDistortion(estimate.distortion, 'stress_normal')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Number(estimate.M_material).toFixed(3)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Number(estimate.build_time).toFixed(3)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.totalCostMaterialPerEstimate(estimate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.totalCostTimePerEstimate(estimate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.costPerEstimate(estimate)))])])
  })], 2)])] : _vm._e(), _vm._v(" "), _vm._l((_vm.nestedEstimates), function(estimate) {
    return [_c('div', {
      key: ("wrapper-" + (estimate.jobOutputPathKey)),
      staticClass: "row col"
    }, [_c('div', {
      key: ("name-" + (estimate.jobOutputPathKey)),
      staticClass: "nested-job-name"
    }, [_c('i', {
      staticClass: "material-icons a3d color btn-delete-estimate",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.deleteJobFromEstimate(estimate.jobOutputPathKey)
        }
      }
    }, [_vm._v("\n                                clear\n                            ")]), _vm._v("\n                            " + _vm._s(estimate.filename) + "\n                        ")]), _vm._v(" "), _vm._l((estimate.plates), function(plate, index) {
      return [_c('div', {
        key: ("plate-number-" + index + "-" + (estimate.jobOutputPathKey)),
        staticClass: "nested-part-name"
      }, [_vm._v("Plate " + _vm._s(index + 1))]), _vm._v(" "), _c('table', {
        key: ("plate-" + index + "-" + (estimate.jobOutputPathKey)),
        staticClass: "estimate-table nested-table"
      }, [_c('tr', [_c('th', {
        attrs: {
          "rowspan": "2"
        }
      }, [_vm._v("Part")]), _vm._v(" "), _c('th', {
        attrs: {
          "rowspan": "2"
        }
      }, [_vm._v("Quantity")]), _vm._v(" "), _c('th', {
        staticClass: "distortion",
        attrs: {
          "colspan": "3"
        }
      }, [_vm._v("On-plate distortion")]), _vm._v(" "), _c('th', {
        staticClass: "distortion",
        attrs: {
          "colspan": "3"
        }
      }, [_vm._v("Off-plate distortion")]), _vm._v(" "), _c('th', {
        attrs: {
          "rowspan": "2"
        }
      }, [_vm._v("Relative Completion Time, h")]), _vm._v(" "), _c('th', {
        attrs: {
          "rowspan": "2"
        }
      }, [_vm._v("Part max Z (mm)")]), _vm._v(" "), _c('th', {
        attrs: {
          "colspan": "4"
        }
      }, [_vm._v("X-Y Bounding Box (mm from 0,0)")])]), _vm._v(" "), _c('tr', [_c('th', {
        staticClass: "distortion"
      }, [_vm._v("X")]), _vm._v(" "), _c('th', {
        staticClass: "distortion"
      }, [_vm._v("Y")]), _vm._v(" "), _c('th', {
        staticClass: "distortion"
      }, [_vm._v("Z")]), _vm._v(" "), _c('th', {
        staticClass: "distortion"
      }, [_vm._v("X")]), _vm._v(" "), _c('th', {
        staticClass: "distortion"
      }, [_vm._v("Y")]), _vm._v(" "), _c('th', {
        staticClass: "distortion"
      }, [_vm._v("Z")]), _vm._v(" "), _c('th', {
        staticClass: "distortion"
      }, [_vm._v("Min X")]), _vm._v(" "), _c('th', {
        staticClass: "distortion"
      }, [_vm._v("Max X")]), _vm._v(" "), _c('th', {
        staticClass: "distortion"
      }, [_vm._v("Min Y")]), _vm._v(" "), _c('th', {
        staticClass: "distortion"
      }, [_vm._v("Max Y")])]), _vm._v(" "), _vm._l((plate), function(part, partIndex) {
        return [_c('tr', {
          key: ("part-" + partIndex + "-" + (estimate.jobOutputPathKey))
        }, [_c('td', [_vm._v(_vm._s(part.filename))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(part.count))]), _vm._v(" "), _c('td', {
          staticClass: "distortion"
        }, [_vm._v(_vm._s(_vm.formatDistortion(part.distortion, 'on_x')))]), _vm._v(" "), _c('td', {
          staticClass: "distortion"
        }, [_vm._v(_vm._s(_vm.formatDistortion(part.distortion, 'on_y')))]), _vm._v(" "), _c('td', {
          staticClass: "distortion"
        }, [_vm._v(_vm._s(_vm.formatDistortion(part.distortion, 'on_z')))]), _vm._v(" "), _c('td', {
          staticClass: "distortion"
        }, [_vm._v(_vm._s(_vm.formatDistortion(part.distortion, 'off_x')))]), _vm._v(" "), _c('td', {
          staticClass: "distortion"
        }, [_vm._v(_vm._s(_vm.formatDistortion(part.distortion, 'off_y')))]), _vm._v(" "), _c('td', {
          staticClass: "distortion"
        }, [_vm._v(_vm._s(_vm.formatDistortion(part.distortion, 'off_z')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s((part.buildTime && part.buildTime[0].toFixed(3)) || part.build_time.toFixed(3)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(part.distortion.partMaxZ ? part.distortion.partMaxZ : part.distortion.partHeight + part.distortion.offsetZ))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(part.distortion.bounding_min[0]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(part.distortion.bounding_max[0]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(part.distortion.bounding_min[1]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(part.distortion.bounding_max[1]))])])]
      }), _vm._v(" "), _c('br'), _vm._v(" "), _c('tr', {
        staticClass: "plate-estimate"
      }, [_c('td', {
        attrs: {
          "colspan": "4"
        }
      }), _vm._v(" "), _c('th', {
        attrs: {
          "colspan": "4"
        }
      }, [_vm._v("Print Time, h:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Number(estimate.timePerPlate[index]).toFixed(3)))]), _vm._v(" "), _c('th', [_vm._v("Material Consumed, kg:")]), _vm._v(" "), _c('td', {
        attrs: {
          "colspan": "4"
        }
      }, [_vm._v(_vm._s(Number(estimate.materialPerPlate[index]).toFixed(3)))])])], 2)]
    }), _vm._v(" "), _c('div', {
      staticClass: "total-estimate"
    }, [_c('div', [_vm._v("Total Print Time:")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(Number(estimate.build_time).toFixed(3)) + " h")]), _vm._v(" "), _c('div', [_vm._v("Total Material Consumed:")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(Number(estimate.M_material).toFixed(3)) + " kg")]), _vm._v(" "), _c('div', [_vm._v("Total Cost for Nested Job:")]), _vm._v(" "), _c('div', [_vm._v("$ " + _vm._s(_vm.costPerEstimate(estimate)))])])], 2)]
  })], 2)]) : _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._v("Estimate Print Costs")]), _vm._v(" "), _c('form', {
    staticClass: "modal-form"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "input-field col s6"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "name": "totalPrintTime",
      "id": "totalPrintTime",
      "disabled": ""
    },
    domProps: {
      "value": _vm.printTime
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "active",
    attrs: {
      "for": "totalPrintTime"
    }
  }, [_vm._v("Total Print Time")])]), _vm._v(" "), _c('div', {
    staticClass: "input-field col s6 cost"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.costPerHour),
      expression: "formData.costPerHour"
    }],
    attrs: {
      "type": "number",
      "min": "0",
      "name": "costPerHour",
      "id": "costPerHour"
    },
    domProps: {
      "value": (_vm.formData.costPerHour)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "costPerHour", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "active",
    attrs: {
      "for": "costPerHour"
    }
  }, [_vm._v("Cost per Print Hour")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "input-field col s6"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "name": "totalMaterial",
      "id": "totalMaterial",
      "disabled": ""
    },
    domProps: {
      "value": _vm.totalMaterial
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "active",
    attrs: {
      "for": "totalMaterial"
    }
  }, [_vm._v("Total Material Required")])]), _vm._v(" "), _c('div', {
    staticClass: "input-field col s6 cost"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.costPerKg),
      expression: "formData.costPerKg"
    }],
    attrs: {
      "type": "number",
      "min": "0",
      "name": "costPerKg",
      "id": "costPerKg"
    },
    domProps: {
      "value": (_vm.formData.costPerKg)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "costPerKg", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "active",
    attrs: {
      "for": "costPerKg"
    }
  }, [_vm._v("Cost per kg")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "radio-group col s6"
  }, [_c('div', {
    staticClass: "radio-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.multiplier),
      expression: "formData.multiplier"
    }],
    attrs: {
      "type": "radio",
      "name": "multiplier",
      "id": "multiplier"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.formData.multiplier, true)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.formData, "multiplier", true)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "multiplier"
    }
  }, [_vm._v("\n                                Multiplier\n                            ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.multiplier),
      expression: "formData.multiplier"
    }],
    attrs: {
      "type": "radio",
      "name": "multiplier",
      "id": "flat"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.formData.multiplier, false)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.formData, "multiplier", false)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "flat"
    }
  }, [_vm._v("\n                                Flat Dollar Amount\n                            ")])])]), _vm._v(" "), (_vm.formData.multiplier) ? _c('div', {
    staticClass: "input-field col s6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.overhead),
      expression: "formData.overhead"
    }],
    attrs: {
      "type": "number",
      "name": "overhead",
      "id": "overhead",
      "step": "0.1",
      "min": "0"
    },
    domProps: {
      "value": (_vm.formData.overhead)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "overhead", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "active",
    attrs: {
      "for": "overhead"
    }
  }, [_vm._v("Overhead and Profit")])]) : _vm._e(), _vm._v(" "), (!_vm.formData.multiplier) ? _c('div', {
    staticClass: "input-field col s6 cost"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.overheadFlat),
      expression: "formData.overheadFlat"
    }],
    attrs: {
      "type": "number",
      "name": "overheadFlat",
      "id": "overheadFlat",
      "step": "0.1"
    },
    domProps: {
      "value": (_vm.formData.overheadFlat)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "overheadFlat", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "active",
    attrs: {
      "for": "overhead"
    }
  }, [_vm._v("Overhead and Profit")])]) : _vm._e()]), _vm._v(" "), (_vm.validationError) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "error"
  }, [_vm._v("\n                        " + _vm._s(_vm.validationError) + "\n                    ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "total-label col s6"
  }, [_vm._v("Total Print Cost")]), _vm._v(" "), _c('div', {
    staticClass: "input-field col s6 cost total"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.totalCost),
      expression: "totalCost"
    }],
    attrs: {
      "type": "text",
      "name": "totalCost",
      "id": "totalCost",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.totalCost)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.totalCost = $event.target.value
      }
    }
  })])])])])]], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-18d6d9ee", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18d6d9ee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/EstimateCost.vue
// module id = 474
// module chunks = 1